<div class="header bg-secondary">
    <div class="float-right">
        <app-language-navbar></app-language-navbar>
    </div>
</div>
